<template>
  <div class="news_wrap psge_news_wrap" v-if="list">
      <a href="news_content" v-for="(news, idx) of list.Items.slice(0, 4)" :key="idx">
          <div class="news_box">
              <div class="news_day">{{news.DBUpdate | moment}}</div>
              <div class="news_icon news_icon_red">{{news.NewsType}}</div>
              <div class="news_content">{{news.Title}}</div>
          </div>
      </a>
  </div>
</template>

<script>
import axios from 'axios'
import {API_URL, userStatus} from './config.js'
import user from './user.js'

export default {
  name: 'RelatedNews',
  props: [],
  data () {
    return {
      list: this.$root.newsListItem
    }
  },
  created () {
    // this.$root.getNewsListByType()
  },
  methods: {
    ...user,
  },
  mounted () {
    // console.log(`${this.name} mounted`)
    // if (this.item) $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
    // $('[data-remodal-id=modal-'+this.item.BookID+']').remodal()
  }
}
</script>


// WEBPACK FOOTER //
// src/RelatedNews.vue